import React from 'react'
import PropTypes from 'prop-types'

import Dialog from 'material-ui/Dialog'
import FlatButton from 'material-ui/FlatButton'
import CircularProgress from 'material-ui/CircularProgress'

import ReferencedEventPhotos from './ReferencedEventPhotos'
import closeIcon from 'resources/close_icon.png'

const Header = ({ onCloseRequested }) => {
  return (
    <div style={styles.header}>
      <div style={styles.heading}>
        Add Photos
      </div>
      <div style={{ marginRight: 16 }}>
        <img src={closeIcon} title='Close' width={16}
          onClick={onCloseRequested}
          style={{ cursor: 'pointer' }} />
      </div>
    </div>
  )
}

Header.propTypes = {
  onCloseRequested: PropTypes.func.isRequired
}

const Actions = ({ onCancelClicked, onSaveClicked }) => {
  return (
    <div style={styles.actions}>
      <FlatButton
        label='Cancel'
        onTouchTap={onCancelClicked}/>
      <FlatButton
        primary={true}
        label='Save'
        onTouchTap={onSaveClicked}/>
    </div>
  )
}

Actions.propTypes = {
  onCancelClicked: PropTypes.func.isRequired,
  onSaveClicked: PropTypes.func.isRequired
}

export default class AddPhotosDialog extends React.Component {

  static propTypes = {
    open: PropTypes.bool.isRequired,
    invoiceEditor: PropTypes.object.isRequired,
    onCloseRequested: PropTypes.func.isRequired,
    onPhotosSelected: PropTypes.func.isRequired
  }

  constructor(props) {
    super(props)
    this.state = {
      selectedPhotos: []
    }
  }

  componentWillReceiveProps(nextProps) {
    // Clear selection when the dialog opens.
    if (nextProps.open) {
      this.setState({
        selectedPhotos: []
      })
    }
  }

  handlePhotoSelectionChanged = (photo, selectionStatus) => {
    // Add photo to the list
    let updated = this.state.selectedPhotos
    if (selectionStatus) {
      updated.push(photo)
    }
    // Remove photo from the list
    else {
      updated = updated.filter(p => p.id !== photo.id)
    }
    this.setState({
      selectedPhotos: updated
    })
  }

  render() {
    if (!this.props.open) {
      return null
    }
    const loading = this.props.invoiceEditor.isLoadingReferencedEvents()
    const referencedEvents = this.props.invoiceEditor.getReferencedEvents() || []
    let content
    if (loading) {
      content = <div style={styles.progress}>
        <CircularProgress thickness={2} />
      </div>
    }
    else
    if (!referencedEvents.length) {
      content = <div style={styles.zeroItems}>No jobs have been referenced in this invoice.</div>
    }
    else {
      content = referencedEvents.map((referencedEvent, index) =>
        <div key={index}>
          <ReferencedEventPhotos
            referencedEvent={referencedEvent}
            style={index && styles.divider || {}}
            onPhotoSelectionChanged={this.handlePhotoSelectionChanged} />
        </div>)
    }
    return (
      <Dialog open={this.props.open}
        onRequestClose={this.props.onCloseRequested}
        actions={
          <Actions
            onCancelClicked={this.props.onCloseRequested}
            onSaveClicked={() => this.props.onPhotosSelected(this.state.selectedPhotos)} />
        }
        title={<Header onCloseRequested={this.props.onCloseRequested} />}
        bodyStyle={styles.dialogBody}
        contentStyle={styles.dialogContent}
        autoScrollBodyContent={true}
        actionsContainerStyle={{ padding: 0 }}>
        <div style={styles.photosContainer}>
          { content }
        </div>
      </Dialog>
    )
  }

}

const styles = {
  photosContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 22,
    marginBottom: 22,
    marginLeft: 22,
    marginRight: 22
  },
  actions: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    height: 48,
    paddingRight: 16,
    backgroundColor: '#fafafa'
  },
  dialogContent: {
    borderRadius: 4,
    // This is a hack as there is a bug in Dialog's definition to properly
    // apply the border radius.
    overflow: 'auto',
    width: 630
  },
  dialogBody: {
    display: 'flex',
    flexDirection: 'column',
    padding: 0,
    borderRadius: 4
  },
  header: {
    display: 'flex',
    displayDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: 48,
    backgroundColor: '#fafafa'
  },
  heading: {
    fontSize: 16,
    marginLeft: 16,
    color: '#212121'
  },
  zeroItems: {
    textAlign: 'center',
    fontSize: 14,
    paddingTop: 12,
    paddingBottom: 12
  },
  progress: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    margin: 22
  },
  divider: {
    marginTop: 18
  }
}



// WEBPACK FOOTER //
// ./src/billing/invoices/modules/photos/AddPhotosDialog.js